/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IEventId, ISuccess, TSuccessString } from '../interfaces';

export const EVENT_COMMERCE_REQUEST_START = 'CommerceRequestEventStart';
export const EVENT_COMMERCE_REQUEST_STOP = 'CommerceRequestEventStop';

/**
 * Additional properties to send along with ending a request
 */
export interface IEventCommerceRequestStopProperties extends IEventId, ISuccess<TSuccessString> {
    statusCode: string;
}
